import { AlertTriangle } from "lucide-react";
import { STATUS_LABELS, STATUS_STYLES } from "@/lib/constants";

export const StabVestBadge = ({ testId }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-red-300 bg-red-50 px-2.5 py-0.5 text-xs font-bold text-red-800">
    <AlertTriangle className="h-3.5 w-3.5 text-red-600" /> Stab vest
  </span>
);

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
      STATUS_STYLES[status] || STATUS_STYLES.scheduled
    }`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-[var(--dot)]" />
    {STATUS_LABELS[status] || status}
  </span>
);

export const ProgressBar = ({ done, total, testId, compact = false }) => {
  const pct = total ? Math.round((done / total) * 100) : 0;
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <div className={`flex-1 overflow-hidden rounded-full bg-slate-200 ${compact ? "h-1.5" : "h-3"}`}>
        <div
          className="h-full rounded-full bg-gradient-to-r from-blue-600 to-emerald-500 transition-[width] duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="font-data whitespace-nowrap text-xs font-semibold text-slate-600">
        {done}/{total}
      </span>
    </div>
  );
};
